import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b01fcbd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-details-page" }
const _hoisted_2 = { class: "customer-details-content" }
const _hoisted_3 = { class: "customer-details-content-title" }
const _hoisted_4 = {
  key: 0,
  class: "row-data"
}
const _hoisted_5 = { class: "row-data" }
const _hoisted_6 = { class: "row-data" }
const _hoisted_7 = { class: "row-data" }
const _hoisted_8 = { class: "row-data" }
const _hoisted_9 = { class: "row-data" }
const _hoisted_10 = { class: "row-data" }
const _hoisted_11 = { class: "row-data" }
const _hoisted_12 = { class: "row-data" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_14 = { class: "send-email-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ViewHeader = _resolveComponent("ViewHeader")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_TextAreaWithClear = _resolveComponent("TextAreaWithClear")!
  const _component_DropdownInput = _resolveComponent("DropdownInput")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_BackAndCancelFooter = _resolveComponent("BackAndCancelFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ViewHeader, {
      text: _ctx.$t('cashier.label.customer-details')
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        id: "customerDetails",
        onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submitForm($event)), ["prevent"])),
        novalidate: ""
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("cashier.header.customer-data")), 1),
        (_ctx.isGroup)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.group-name")), 1),
              _createVNode(_component_TextInput, {
                clearable: true,
                modelValue: _ctx.customer.groupName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.customer.groupName) = $event)),
                scope: _ctx.validation.scope,
                rules: _ctx.validation.rules.groupName
              }, null, 8, ["modelValue", "scope", "rules"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.last-name")), 1),
          _createVNode(_component_TextInput, {
            clearable: true,
            modelValue: _ctx.customer.lastName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customer.lastName) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.lastName
          }, null, 8, ["modelValue", "scope", "rules"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.first-name")), 1),
          _createVNode(_component_TextInput, {
            clearable: true,
            modelValue: _ctx.customer.firstName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customer.firstName) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.firstName
          }, null, 8, ["modelValue", "scope", "rules"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.mobile-phone")), 1),
          _createVNode(_component_TextInput, {
            clearable: true,
            modelValue: _ctx.customer.mobile,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.customer.mobile) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.mobile,
            class: _normalizeClass({ invalidMobile: _ctx.invalidMobile })
          }, null, 8, ["modelValue", "scope", "rules", "class"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.email")), 1),
          _createVNode(_component_TextInput, {
            clearable: true,
            modelValue: _ctx.customer.email,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customer.email) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.email
          }, null, 8, ["modelValue", "scope", "rules"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.ext-sys-number")), 1),
          _createVNode(_component_TextInput, {
            clearable: true,
            modelValue: _ctx.customer.pnr,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.customer.pnr) = $event)),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.pnr
          }, null, 8, ["modelValue", "scope", "rules"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.remarks")), 1),
          _createVNode(_component_TextAreaWithClear, {
            modelValue: _ctx.customer.remarks,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.customer.remarks) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t("cashier.label.source")), 1),
          _createVNode(_component_DropdownInput, {
            modelValue: _ctx.customer.sourceOptionId,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.customer.sourceOptionId) = $event)),
            options: _ctx.orderSourceOptions,
            showClearProp: true,
            optionLabel: "text",
            optionValue: "id",
            placeholder: _ctx.$t('cashier.placeholder.select-order-source'),
            scope: _ctx.validation.scope,
            rules: _ctx.validation.rules.sourceOptionId
          }, null, 8, ["modelValue", "options", "placeholder", "scope", "rules"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_Checkbox, {
              modelValue: _ctx.customer.sendTicket,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.customer.sendTicket) = $event)),
              binary: true
            }, null, 8, ["modelValue"]),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("cashier.label.send-ticket-email-sms")), 1)
          ])
        ]),
        (!_ctx.isSave)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "skip-row",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)))
            }, _toDisplayString(_ctx.$t("cashier.label.skip-customer-data")), 1))
          : _createCommentVNode("", true)
      ], 32)
    ]),
    _createVNode(_component_BackAndCancelFooter)
  ]))
}